import { useQuery } from "@tanstack/react-query";
import { SAMLConfig } from "@graylog/enterprise-api";
const useSAMLDefaultAttributeMapping = () => {
  const { isLoading, isError, data } = useQuery({
    queryKey: ["saml.default.attribute.mapping"],
    queryFn: () => SAMLConfig.getIdpDefaultAttributeMapping()
  });
  if (isError) {
    return {
      isLoading: false,
      defaultAttributeMapping: void 0
    };
  }
  return {
    isLoading,
    defaultAttributeMapping: data
  };
};
export default useSAMLDefaultAttributeMapping;
